export type PerformanceDebugData = Record<string, unknown>;

export interface IPerformanceDebugTraceOptions {
    consolePrefix?: string;
    eventName?: string;
    group?: string;
    storageKey?: string;
    windowKey?: string;
}

export interface IPerformanceDebugTrace {
    traceId: string;
    group: string;
    mark: (step: string, data?: PerformanceDebugData) => void;
    end: (step: string, data?: PerformanceDebugData) => void;
}

export interface IPerformanceDebugEntry {
    data?: PerformanceDebugData;
    deltaMs: number;
    elapsedMs: number;
    flow: string;
    group: string;
    step: string;
    traceId: string;
    timestamp: string;
}

declare global {
    interface Window {
        __pgPerformanceDebugLogs?: IPerformanceDebugEntry[];
    }
}

export const DEFAULT_PERFORMANCE_DEBUG_GROUP = "default";
export const PERFORMANCE_DEBUG_STORAGE_KEY = "pgPerformanceDebug";
export const PERFORMANCE_DEBUG_EVENT_NAME = "pgPerformanceDebugLog";
export const PERFORMANCE_DEBUG_WINDOW_KEY = "__pgPerformanceDebugLogs";

const PERFORMANCE_DEBUG_PREFIX = "[PG_PERF]";

let traceCounter = 0;

export const isPerformanceDebugEnabled = (storageKey = PERFORMANCE_DEBUG_STORAGE_KEY) => {
    if (typeof window === "undefined") {
        return false;
    }

    try {
        const storedValue = window.localStorage.getItem(storageKey) ?? window.sessionStorage.getItem(storageKey);

        return storedValue === "1" || storedValue === "true";
    } catch (_error) {
        return false;
    }
};

export const getPerformanceDebugLogs = (windowKey = PERFORMANCE_DEBUG_WINDOW_KEY): IPerformanceDebugEntry[] => {
    if (typeof window === "undefined") {
        return [];
    }

    const logs = (window as unknown as Record<string, IPerformanceDebugEntry[] | undefined>)[windowKey];

    return Array.isArray(logs) ? logs : [];
};

export const createPerformanceDebugTrace = (
    flow: string,
    initialData?: PerformanceDebugData,
    options?: IPerformanceDebugTraceOptions
): IPerformanceDebugTrace => {
    const consolePrefix = options?.consolePrefix ?? PERFORMANCE_DEBUG_PREFIX;
    const eventName = options?.eventName ?? PERFORMANCE_DEBUG_EVENT_NAME;
    const group = options?.group ?? DEFAULT_PERFORMANCE_DEBUG_GROUP;
    const storageKey = options?.storageKey ?? PERFORMANCE_DEBUG_STORAGE_KEY;
    const traceId = `${flow}-${Date.now().toString(36)}-${(++traceCounter).toString(36)}`;
    const windowKey = options?.windowKey ?? PERFORMANCE_DEBUG_WINDOW_KEY;
    const startTime = getCurrentTime();
    let lastMarkTime = startTime;

    const writeMark = (step: string, data?: PerformanceDebugData) => {
        if (!isPerformanceDebugEnabled(storageKey)) {
            return;
        }

        const currentTime = getCurrentTime();
        const entry: IPerformanceDebugEntry = {
            data: sanitizeData(data),
            deltaMs: roundTime(currentTime - lastMarkTime),
            elapsedMs: roundTime(currentTime - startTime),
            flow,
            group,
            step,
            traceId,
            timestamp: new Date().toISOString()
        };

        lastMarkTime = currentTime;
        writeEntry(entry, {consolePrefix, eventName, windowKey});
    };

    writeMark("trace:start", initialData);

    return {
        group,
        traceId,
        mark: writeMark,
        end: (step, data) => writeMark(step, {...data, traceEnded: true})
    };
};

const getCurrentTime = () => {
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
        return performance.now();
    }

    return Date.now();
};

const roundTime = (value: number) => Math.round(value * 10) / 10;

const sanitizeData = (data?: PerformanceDebugData) => {
    if (!data) {
        return undefined;
    }

    try {
        JSON.stringify(data);

        return data;
    } catch (_error) {
        return {serializationError: true};
    }
};

const writeEntry = (entry: IPerformanceDebugEntry, options: {consolePrefix: string; eventName: string; windowKey: string}) => {
    if (typeof window !== "undefined") {
        const performanceDebugWindow = window as unknown as Record<string, IPerformanceDebugEntry[] | undefined>;
        performanceDebugWindow[options.windowKey] = performanceDebugWindow[options.windowKey] ?? [];
        performanceDebugWindow[options.windowKey]?.push(entry);
        window.dispatchEvent(new CustomEvent(options.eventName, {detail: entry}));
    }

    console.info(`${options.consolePrefix} ${JSON.stringify(entry)}`);
};
export type PerformanceDebugData = Record<string, unknown>;

export interface IPerformanceDebugTraceOptions {
    consolePrefix?: string;
    eventName?: string;
    group?: string;
    storageKey?: string;
    windowKey?: string;
}

export interface IPerformanceDebugTrace {
    traceId: string;
    group: string;
    mark: (step: string, data?: PerformanceDebugData) => void;
    end: (step: string, data?: PerformanceDebugData) => void;
}

export interface IPerformanceDebugEntry {
    data?: PerformanceDebugData;
    deltaMs: number;
    elapsedMs: number;
    flow: string;
    group: string;
    step: string;
    traceId: string;
    timestamp: string;
}

declare global {
    interface Window {
        __pgPerformanceDebugLogs?: IPerformanceDebugEntry[];
    }
}

export const DEFAULT_PERFORMANCE_DEBUG_GROUP = "default";
export const PERFORMANCE_DEBUG_STORAGE_KEY = "pgPerformanceDebug";
export const PERFORMANCE_DEBUG_EVENT_NAME = "pgPerformanceDebugLog";
export const PERFORMANCE_DEBUG_WINDOW_KEY = "__pgPerformanceDebugLogs";

const PERFORMANCE_DEBUG_PREFIX = "[PG_PERF]";

let traceCounter = 0;

export const isPerformanceDebugEnabled = (storageKey = PERFORMANCE_DEBUG_STORAGE_KEY) => {
    if (typeof window === "undefined") {
        return false;
    }

    try {
        const storedValue = window.localStorage.getItem(storageKey) ?? window.sessionStorage.getItem(storageKey);

        return storedValue === "1" || storedValue === "true";
    } catch (_error) {
        return false;
    }
};

export const getPerformanceDebugLogs = (windowKey = PERFORMANCE_DEBUG_WINDOW_KEY): IPerformanceDebugEntry[] => {
    if (typeof window === "undefined") {
        return [];
    }

    const logs = (window as unknown as Record<string, IPerformanceDebugEntry[] | undefined>)[windowKey];

    return Array.isArray(logs) ? logs : [];
};

export const createPerformanceDebugTrace = (
    flow: string,
    initialData?: PerformanceDebugData,
    options?: IPerformanceDebugTraceOptions
): IPerformanceDebugTrace => {
    const consolePrefix = options?.consolePrefix ?? PERFORMANCE_DEBUG_PREFIX;
    const eventName = options?.eventName ?? PERFORMANCE_DEBUG_EVENT_NAME;
    const group = options?.group ?? DEFAULT_PERFORMANCE_DEBUG_GROUP;
    const storageKey = options?.storageKey ?? PERFORMANCE_DEBUG_STORAGE_KEY;
    const traceId = `${flow}-${Date.now().toString(36)}-${(++traceCounter).toString(36)}`;
    const windowKey = options?.windowKey ?? PERFORMANCE_DEBUG_WINDOW_KEY;
    const startTime = getCurrentTime();
    let lastMarkTime = startTime;

    const writeMark = (step: string, data?: PerformanceDebugData) => {
        if (!isPerformanceDebugEnabled(storageKey)) {
            return;
        }

        const currentTime = getCurrentTime();
        const entry: IPerformanceDebugEntry = {
            data: sanitizeData(data),
            deltaMs: roundTime(currentTime - lastMarkTime),
            elapsedMs: roundTime(currentTime - startTime),
            flow,
            group,
            step,
            traceId,
            timestamp: new Date().toISOString()
        };

        lastMarkTime = currentTime;
        writeEntry(entry, {consolePrefix, eventName, windowKey});
    };

    writeMark("trace:start", initialData);

    return {
        group,
        traceId,
        mark: writeMark,
        end: (step, data) => writeMark(step, {...data, traceEnded: true})
    };
};

const getCurrentTime = () => {
    if (typeof performance !== "undefined" && typeof performance.now === "function") {
        return performance.now();
    }

    return Date.now();
};

const roundTime = (value: number) => Math.round(value * 10) / 10;

const sanitizeData = (data?: PerformanceDebugData) => {
    if (!data) {
        return undefined;
    }

    try {
        JSON.stringify(data);

        return data;
    } catch (_error) {
        return {serializationError: true};
    }
};

const writeEntry = (entry: IPerformanceDebugEntry, options: {consolePrefix: string; eventName: string; windowKey: string}) => {
    if (typeof window !== "undefined") {
        const performanceDebugWindow = window as unknown as Record<string, IPerformanceDebugEntry[] | undefined>;
        performanceDebugWindow[options.windowKey] = performanceDebugWindow[options.windowKey] ?? [];
        performanceDebugWindow[options.windowKey]?.push(entry);
        window.dispatchEvent(new CustomEvent(options.eventName, {detail: entry}));
    }

    console.info(`${options.consolePrefix} ${JSON.stringify(entry)}`);
};
